import Vue from 'vue'
import masker from '@/shared/mask/masker'
import moment from 'vue-moment-lib'

Vue.filter('toCnpj', (value) => {
    return masker(value, '##.###.###/####-##')
})

Vue.filter('toCpf', (value) => {
    return masker(value, '###.###.###-##')
})

Vue.filter('toStatus', (value) => {
    return `<strong>${value}</strong>`
})

Vue.filter('toTelefone', (value) => {
    return masker(value, ['(##) #####-####', '(##) ####-####'])
})

Vue.filter('toCep', (value) => {
    return masker(value, '#####-###')
})

Vue.filter('toDate', (value) => {
    return value ? moment(value).format('DD/MM/YYYY') : ''
})

Vue.filter('toDateTime', (value) => {
    return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
})
